
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import DownIcon from '@material-ui/icons/KeyboardArrowDown';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import Grid from '@material-ui/core/Grid';

import Icon from '@material-ui/core/Icon';
import DeleteIcon from '@material-ui/icons/Delete';


import no from './misc-seriously.svg';
import double_no from './annoyed-facepalm-picard.svg';
import yes_and_no from './cat-lol.svg';
import yes from './misc-actually-pretty-badass.svg'
import yesyes from './breathing.gif'
import fuckyes from './takemymoney.gif'

import Divider from '@material-ui/core/Divider';
import Pie3D from 'react-pie3d'
import firebase from './fire.js';
import {
  FacebookShareButton,
  GooglePlusShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  PinterestShareButton,
  VKShareButton,
  OKShareButton,
  RedditShareButton,
  TumblrShareButton,
  LivejournalShareButton,
  MailruShareButton,
  ViberShareButton,
  WorkplaceShareButton,
  LineShareButton,
  EmailShareButton,
} from 'react-share';

import {
  FacebookIcon,
  TwitterIcon,
  TelegramIcon,
  WhatsappIcon,
  GooglePlusIcon,
  LinkedinIcon,
  PinterestIcon,
  VKIcon,
  OKIcon,
  RedditIcon,
  TumblrIcon,
  LivejournalIcon,
  MailruIcon,
  ViberIcon,
  WorkplaceIcon,
  LineIcon,
  EmailIcon,
} from 'react-share';
import TextField from "@material-ui/core/TextField/TextField";
import RecipeReviewCard from "./RecipeReviewCard";
import CardHeader from "@material-ui/core/CardHeader/CardHeader";
import Avatar from "@material-ui/core/Avatar/Avatar";
import IconButton from "@material-ui/core/IconButton/IconButton";
import MoreVertIcon from "@material-ui/core/SvgIcon/SvgIcon";
import classnames from 'classnames';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import firebasesdk from 'firebase';

const styles = {
  card: {
    marginTop: '2rem',
    margin: '0 auto',
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  img_button:{
    width: '100px'
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    // alignItems: 'center',
    // justifyContent: 'center'

  }
};



class Idea extends Component {



  state = {

    votes: 0,
    data: [
      {
        value: 1,
        color: "green",
        label: 'yes'
      },
      {
        value: 1,
        color: "red",
        label: 'No'
      },
    ]
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });

  };

  handleButtonClick = (postId) => {
    var user = firebase.auth().currentUser;

    firebase.database().ref('uservotes/'+user.email).push({
      [postId]: postId,
    });
    // let new_arr = [...this.props.post.data];
    // switch(button_name){
    //
    //   case "yes":
    //     new_arr[0].value += 1;
    //     break;
    //   default:
    // }
    //   var postKey = this.props.ref_id;
    //   var updates = {};
    //   updates['/posts/' + postKey+'/data/'] = new_arr;
    //   updates['/posts/' + postKey+'/votes/'] = this.props.post.votes + 1;
    //
    //   firebase.database().ref().update(updates);
  }


  handleCommentSend = () => {

    let new_arr = [...this.props.post.comments];
    new_arr.push({comment_text: "bladlwad"})
    var postKey = this.props.ref_id;
    var updates = {};
    updates['/posts/' + postKey+'/comments/'] = new_arr;

    firebase.database().ref().update(updates);
  }

  
  render(){
  let width = window.screen.availWidth;
  let cardWidth=''
  if (width > 720) {
    cardWidth='60%';
  } else {
    cardWidth="95%"
  }

  const { classes } = this.props;
  return (
    <div style={{marginBottom: "2rem"}}>
      <Card className={classes.card} style={{maxWidth:cardWidth}}>

        <CardHeader

          action={
            <IconButton>
              <MoreVertIcon />
            </IconButton>
          }
          title={"Problem: \""+this.props.post.name+"\""}
          // subheader="September 14, 2016"
        />
      <Grid container spacing={24}>
      <Grid item xs={12} md={6}>

        <CardContent>
          {/*<Typography gutterBottom variant="headline" component="h2">*/}
            {/*{this.props.post.name}*/}
          {/*</Typography>*/}
          {/*<Typography component="p" style={{marginBottom: "1rem"}}>*/}
            {/*{"Problem: \""+this.props.post.description+"\""}*/}
          {/*</Typography>*/}
          <Typography component="p">Is this really a problem that needs to be solved?</Typography>
          <Typography component="p">This is what others voted:</Typography>
          <Pie3D data={this.props.post.data}/>
          <Typography variant="h2">Votes: {this.props.post.votes} </Typography>
          <Typography component="p">What do you think?</Typography>
          <CardActions className={classes.actions}
            style={{
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Button variant="outlined" color="secondary" onClick={()=> this.handleButtonClick('no')}   size="small" >
              NO
            </Button>
            <Button variant="outlined" color="primary" onClick={()=> this.handleButtonClick('yes')}   size="small" >
              YES
            </Button>
          </CardActions>


          {/*<Typography>*/}
            {/*Share it*/}
          {/*</Typography>*/}





        </CardContent>
        </Grid>

      <Grid item xs={12} md={6} >
        <CardContent>

        </CardContent>
        <RecipeReviewCard post={this.props.post}/>


        </Grid>



        </Grid>

        <CardActions className={classes.actions} disableActionSpacing>
          <IconButton aria-label="Add to favorites">
            <TwitterShareButton
              url={"https://1001problems.com"}
              title={"Decide if this is a problem worth solving: " + this.props.post.description}
              hashtags={["1001problems","greatproblems","solvethisproblem"]}
            >
              <TwitterIcon
                size={32}
                round />
            </TwitterShareButton>
          </IconButton>



        </CardActions>
      </Card>
    </div>
  );
}
}

Idea.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Idea);


// WEBPACK FOOTER //
// ./src/Idea.js